export { InstoreEnrollmentPage } from './instore-enrollment-page';
export { CenteredColumn, StepPanel, StepFooter, StepHeader } from './shared-components';

export const INSTORE_ENROLLMENT_ROUTE = '/instore-enrollment';
export const INSTORE_ENROLLMENT_SOURCE = 'instore-enrollment';
